// extracted by mini-css-extract-plugin
export default {"main":"PrimaryButton_main__cU2Is","transparent":"PrimaryButton_transparent__al90V","icon":"PrimaryButton_icon__TD1Vb","disabled":"PrimaryButton_disabled__GIcRE"};